import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, mergeProps as _mergeProps, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "login-wrapper" };
const _hoisted_2 = { class: "animate login-form clearfix" };
const _hoisted_3 = { class: "form-container clearfix" };
const _hoisted_4 = /*#__PURE__*/ _createStaticVNode("<div class=\"form-header dark clearfix\"><div class=\"float-start\"><i class=\"fa-stack fa-lg fa-2x white-text\"><i class=\"fa fa-circle fa-stack-2x\"></i> <i class=\"fa fa-unlock-alt fa-stack-1x fa-inverse dark-blue-text\"></i></i> <h1 class=\"content-title hidden-xs\">\r\n\t\t\t\t\t\t\tForgot your password?\r\n\t\t\t\t\t\t</h1></div></div>", 1);
const _hoisted_5 = { class: "form-body clearfix bg-white" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("div", { class: "col-xs-12 col-sm-12 top10" }, "\r\n\t\t\t\t\t\tForgot your account's password or having trouble logging into your account? Enter your account name and we'll send you a recovery link.\r\n\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_7 = { class: "col-xs-12 col-sm-12 top10" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("label", { class: "normal" }, "\r\n\t\t\t\t\t\t\tUsername\r\n\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_9 = { class: "invalid-feedback" };
const _hoisted_10 = { class: "col-xs-12 col-sm-12 top20" };
const _hoisted_11 = { class: "float-start top5" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a, _b;
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_router_link = _resolveComponent("router-link");
    const _component_b_button = _resolveComponent("b-button");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_7, [
                        _hoisted_8,
                        _createTextVNode(),
                        _createVNode(_component_b_form_input, _mergeProps(_ctx.userNameVal, {
                            type: "text",
                            modelValue: _ctx.userName,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.userName) = $event)),
                            modelModifiers: { trim: true },
                            name: "username",
                            class: { 'is-invalid': (_a = _ctx.errors) === null || _a === void 0 ? void 0 : _a.username },
                            onKeyup: _withKeys(_ctx.requestPasswordReset, ["enter"]),
                            disabled: _ctx.requestReceived,
                            autocomplete: "userName",
                            required: ""
                        }), null, 16 /* FULL_PROPS */, ["modelValue", "class", "onKeyup", "disabled"]),
                        _createTextVNode(),
                        _withDirectives(_createElementVNode("div", _hoisted_9, "\r\n\t\t\t\t\t\t\t* Please enter your login\r\n\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                            [_vShow, (_b = _ctx.errors) === null || _b === void 0 ? void 0 : _b.userName]
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_router_link, {
                                to: { name: 'login' },
                                class: "blue float-end"
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\tReturn to login page\r\n\t\t\t\t\t\t\t")
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _createTextVNode(),
                        _createVNode(_component_b_button, {
                            type: "button",
                            class: "float-end",
                            variant: "primary",
                            onClick: _ctx.requestPasswordReset,
                            disabled: _ctx.requestReceived
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.statusText), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick", "disabled"])
                    ])
                ])
            ])
        ])
    ]));
}
